import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import reduxUtils from 'util/redux';
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import classnames from 'classnames';
import Icon from 'components/icon';
import offsetTop from 'util/dom/offset-top';
import imagesLoaded from 'util/dom/images-loaded';
import { accordionEasingFn, accordionSpeed } from 'constants/transitions-props';

export class Question extends PureComponent {
    static defaultProps = {
        onOpen: noop,
        onClose: noop,
        onClosing: noop,
        onOpening: noop,
    };

    static propTypes = {
        id: PropTypes.number.isRequired,
        slug: PropTypes.string.isRequired,
        answer: PropTypes.string.isRequired,
        has_anchors: PropTypes.bool.isRequired,
        mustBeClosed: PropTypes.bool.isRequired,
        question: PropTypes.string.isRequired,
        onOpen: PropTypes.func.isRequired,
        onClose: PropTypes.func.isRequired,
        onClosing: PropTypes.func.isRequired,
        onOpening: PropTypes.func.isRequired,
        headerHeight: PropTypes.number.isRequired,
    };

    state = {
        isOpen: false,
    };

    componentDidMount() {
        if (!this.props.mustBeClosed || this.props.has_anchors && window.location.hash.replace('#', '') === this.props.slug) {
            // hack to check firs when all the images in the current DOM are loaded
            // and then scroll to the right answer position
            imagesLoaded().then(() => {
                this.timer = setTimeout(() => {
                    window.scroll({
                        top: offsetTop(this.refs.header) - this.props.headerHeight,
                        left: 0,
                        behavior: 'smooth',
                    });
                }, accordionSpeed);
            });

            this.refs.root.openCollapsible();
        }
    }

    componentWillReceiveProps({ mustBeClosed }) {
        if (mustBeClosed && this.state.isOpen) {
            this.refs.root.closeCollapsible();
        }
    }

    componentWillUnmount() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }

    onClose = () => {
        this.setState({ isOpen: false });
        this.props.onClose();
    };

    onClosing = () => {
        this.props.onClosing();
    };

    onOpen = () => {
        this.props.onOpen();

        if (this.props.has_anchors) {
            window.location.hash = this.props.slug;
        }

        this.setState({ isOpen: true });
    };

    onOpening = () => {
        this.props.onOpening();
    };

    renderAccordionHeader() {
        const { question } = this.props;
        const { isOpen } = this.state;
        return (
            <div ref="header" className="cms-faq--question">
                <h3 className="u-reset">{question}</h3>
                <Icon className={classnames('cms-faq--icon', {
                    'cms-faq--icon__is-highlighted': isOpen,
                })} symbol={`chevron-${ isOpen ? 'up' : 'down' }`} size="small"/>
            </div>
        );
    }

    render() {
        const { answer } = this.props;

        return (
            <Collapsible
                ref="root"
                lazyRender={true}
                transitionTime={accordionSpeed}
                easing={accordionEasingFn}
                onOpening={this.onOpening}
                onClosing={this.onClosing}
                onOpen={this.onOpen}
                onClose={this.onClose}
                className="faq-cms--item"
                openedClassName="faq-cms--item faq-cms--item__is-active"
                trigger={this.renderAccordionHeader()}>
                <div className="cms-faq--answer" dangerouslySetInnerHTML={{ __html: answer }}/>
            </Collapsible>
        );
    }
}

export default connect(
    reduxUtils.mapStateToProps({
        headerHeight: 'header.height',
    }),
)(Question);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/faq/question.js